import { IDemoAccountConfigOption } from './types';

export const TNC_URL = `/docs/terms-of-service.pdf`;
export const PDPA_URL = `/docs/privacy-policy.pdf`;
export const PROD_AQ_URL = `https://aquariux.com`;
export const SIT_AQ_URL = `https://aqweb.s20ip12.com`;

export const DEPOSIT_OPTIONS: IDemoAccountConfigOption[] = [
  { label: '3,000', value: 3000 },
  { label: '5,000', value: 5000 },
  { label: '10,000', value: 10000 },
  { label: '25,000', value: 25000 },
  { label: '50,000', value: 50000 },
  { label: '100,000', value: 100000 },
  { label: '500,000', value: 500000 },
  { label: '1,000,000', value: 1000000 },
  { label: '5,000,000', value: 5000000 }
];
